<template>
  <div>
    <v-data-table
      mobile-breakpoint="0"
      item-key="id"
      :options.sync="BankAccountTableOptions"
      :server-items-length="totalItems"
      :headers="originHeaders"
      :items-per-page="10"
      :items="bankAccounts"
      :footer-props="footerTable"
      loading-text="Đang Tải"
      :loading="loading"
    >
      <template v-slot:no-data>
        <div class="my-14 font-weight-bold">
          <div>Hiện tại chưa có thông tin trong danh sách.</div>
        </div>
      </template>

      <template v-slot:[`item.class`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div v-on="on" style="text-decoration: none; white-space: nowrap">
              <router-link v-on="on" style="text-decoration: none; white-space: nowrap" :to="'/class/' + item.id"
                >{{ item.title }}
              </router-link>
            </div>
          </template>
          <span>Xem lớp</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.grade`]="{ item }">
        {{ item.grade ? item.grade.title : '' }}
      </template>
      <template v-slot:[`item.headTeacher`]="{ item }">
        <router-link
          v-if="item.teachers[0]"
          class="text-decoration-none"
          :to="'/teacher/' + item.teachers[0].id"
          >{{ item.teachers && item.teachers[0].name }}
        </router-link>
      </template>
      <template v-slot:[`item.type`]="{ item }">
        {{ getType(item.bankAccount && item.bankAccount.type) }}
      </template>
      <template v-slot:[`item.account`]="{ item }">
        <div class="my-2">
          <span md="12">{{ get(item.bankAccount, 'bankName', '').toUpperCase() }}</span
          ><br />
          <span>{{ item.bankAccount && item.bankAccount.accountNumber }}</span
          ><br />
          <span class="text-gray">{{ get(item.bankAccount, 'accountHolder', '').toUpperCase() }}</span>
        </div>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn v-if="$auth.policies['update-bank-account']" class="elevation-0" icon @click="editBankAccount(item.id)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <DialogEditBankAccount ref="dialog-edit-bank-account" />
  </div>
</template>
<script>
import get from 'lodash-es/get'
import { mapActions, mapGetters } from 'vuex'
import DialogEditBankAccount from '@/modules/tuitionFee/bank-account/DialogEditBankAccount'

export default {
  components: {
    DialogEditBankAccount,
  },
  data() {
    return {
      get,
      BankAccountTableOptions: {},
      originHeaders: [
        {
          text: 'Tên lớp',
          value: 'class',
          align: 'left',
          sortable: false,
          show: true,
          width: '12%',
        },
        {
          text: 'Học phần',
          value: 'grade',
          align: 'left',
          sortable: false,
          show: true,
          width: '10%',
        },
        {
          text: 'Giáo viên chủ nhiệm',
          value: 'headTeacher',
          align: 'left',
          sortable: false,
          show: true,
          width: '22%',
        },
        {
          text: 'Phân loại tài khoản',
          value: 'type',
          align: 'left',
          sortable: false,
          show: true,
          width: '15%',
        },
        {
          text: 'Số tài khoản',
          value: 'account',
          align: 'left',
          sortable: false,
          show: true,
          width: '31%',
        },
        {
          text: 'Thao tác',
          value: 'action',
          align: 'center',
          sortable: false,
          show: true,
          width: '10%',
        },
      ],
    }
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      bankAccounts: 'bankAccount/bankAccounts',
      pageText: 'bankAccount/pageText',
      loading: 'bankAccount/loading',
      totalItems: 'bankAccount/totalItems',
    }),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số học viên mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  methods: {
    ...mapActions('bankAccount', ['requestPageSettings']),
    getType(type) {
      switch (type) {
        case 'default': {
          return 'Tài khoản GVCN'
        }
        case 'custom': {
          return 'Tài khoản khác'
        }
      }
    },
    editBankAccount(idClass) {
      this.$dialog.confirm({
        title: 'Xác nhận chỉnh sửa?',
        text: '<div>Thay đổi thông tin tài khoản ngân hàng có thể ảnh hưởng đến các giao dịch trong tương lai. Bạn muốn tiếp tục chỉnh sửa?</div>',
        okText: 'XÁC NHẬN',
        cancelText: 'Hủy',
        done: async () => {
          this.$refs['dialog-edit-bank-account'].openDialog(idClass)
        },
      })
    },
  },
  filters: {
    getCurrentClass(currentClass) {
      return currentClass == null ? '' : currentClass.title
    },
  },
  watch: {
    BankAccountTableOptions: {
      async handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          await this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.text-gray {
  color: #797979;
}
</style>
